import React from 'react';
import { Button } from 'antd';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { nullSafeGet } from '../../utils/DataAccessUtils';
import {
	siteSurveyTemplatesRestCrudThunksForBuyer,
	siteSurveyTemplatesRestCrudThunksForSupplier,
} from '../../thunks/site_survey_templates_thunks';
import AccessPermissionChecker from '../common/AccessPermissionChecker';
import { PERMISSION_NAMES } from '../../utils/AuthUtils';
import DeleteConfirmButton from '../delete_pop_confirm/DeletePopConfirm';
import { withUserType } from '../withUserType';
import { ROLE_TYPES } from '../../utils/DataConstants';
import queryString from 'querystring';
import { updateNavbarState } from '../../actions/navbar_actions';
import DetailPageHeader from '../detail_page_header/DetailPageHeader';

require('./SiteSurveyTemplatesDetailPage.less');

interface SiteSurveyTemplatesDetailPageState {}

class SiteSurveyTemplatesDetailPage extends React.Component<
	any,
	SiteSurveyTemplatesDetailPageState
> {
	componentDidMount() {
		const {
			getSiteSurveyTemplate,

			match,
			location,
			updateNavbar,
			userType,
		} = this.props;
		const siteSurveyTemplateId = match.params.id;
		getSiteSurveyTemplate(siteSurveyTemplateId);

		let searchString = location.search;
		if (searchString[0] === '?') {
			searchString = searchString.slice(1);
		}
		const queryParams = queryString.parse(searchString);
		if (queryParams.backlinkParams) {
			updateNavbar(
				'Back To Site Survey Templates',
				`/${userType}/siteSurveys/overview/templates/overview?${queryParams.backlinkParams}`
			);
			this.setState({ backlinkParams: queryParams.backlinkParams });
		}
	}

	handleTabChange = (key) => {
		const { history, match, userType } = this.props;
		const siteSurveyTemplateId = match.params.id;
		history.push(`/${userType}/siteSurveys/templates/detail/${siteSurveyTemplateId}/${key}`);
	};

	checkTabActive = (key) => {
		const { history } = this.props;
		const pathname = history.location.pathname;
		return pathname.indexOf(key) !== -1;
	};

	handleDelete = () => {
		const { history, deleteSiteSurveyTemplate, siteSurveyTemplate, userType } = this.props;
		deleteSiteSurveyTemplate(siteSurveyTemplate).then(() => {
			history.push(`/${userType}/siteSurveys/overview/templates/overview`);
		});
	};

	render() {
		const { siteSurveyTemplate, siteSurveyTemplatesFetching, companyConfig, match, userType } =
			this.props;
		const siteSurveyTemplateId = match.params.id;
		const tabs = [
			{
				key: 'details',
				name: 'Overview',
			},
		];
		return (
			<div>
				<DetailPageHeader
					exactPath={`/${userType}/siteSurveys/templates/detail/:id`}
					redirectPath={`/${userType}/siteSurveys/templates/detail/${siteSurveyTemplateId}/details`}
					backLinkText={'Back to site surveys Templates'}
					backLinkTo={`/${userType}/siteSurveys/overview/templates/overview`}
					title={siteSurveyTemplatesFetching ? null : siteSurveyTemplate.title}
					subtitle={null}
					actions={[
						<AccessPermissionChecker name={PERMISSION_NAMES.MODIFY_SITE_SURVEY_TEMPLATES}>
							<DeleteConfirmButton
								onConfirm={this.handleDelete}
								title={'Are you sure you want to delete this site survey template?'}
							>
								<Button ghost={true}>Delete</Button>
							</DeleteConfirmButton>
						</AccessPermissionChecker>,
					]}
					tabs={tabs}
					backgroundColor={nullSafeGet('detail.config.theme.navblock', companyConfig)}
					handleTabChange={this.handleTabChange}
					checkTabActive={this.checkTabActive}
					childRoutes={this.props.childRoutes}
				/>
			</div>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	siteSurveyTemplatesFetching: state.site_survey_templates.fetching,
	siteSurveyTemplate: state.site_survey_templates.detail,
	companyConfig: state.company_config,
	match: ownProps.match,
	history: ownProps.history,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
	getSiteSurveyTemplate: (id) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? siteSurveyTemplatesRestCrudThunksForSupplier.readOne(id)
				: siteSurveyTemplatesRestCrudThunksForBuyer.readOne(id)
		),
	deleteSiteSurveyTemplate: (entity) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? siteSurveyTemplatesRestCrudThunksForSupplier.delete(entity, 'id', null, true)
				: siteSurveyTemplatesRestCrudThunksForBuyer.delete(entity, 'id', null, true)
		),
	updateNavbar: (backlinkTitle, backlinkTo, navbarBackgroundColor) =>
		dispatch(updateNavbarState(backlinkTitle, backlinkTo, navbarBackgroundColor)),
});

export default withUserType(
	withRouter<any, any>(
		connect(mapStateToProps, mapDispatchToProps)(SiteSurveyTemplatesDetailPage as any)
	) as any
);
